module.exports = __webpack_public_path__ + "static/media/valogo_yellow.7434d9e7.svg";